import { render } from "./CameraReadyPapersView.vue?vue&type=template&id=6bc219de"
import script from "./CameraReadyPapersView.vue?vue&type=script&lang=js"
export * from "./CameraReadyPapersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__